import axios from 'axios';
import { PostAdjustmentParams } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/RefactoredAdjustmentModals/serverProxy/createAdjustment';

export default async function editAdjustment({ adjustmentPostRequest }: PostAdjustmentParams) {
  return axios.post(`api/beaconforecast/UpdateAdjustments`, [adjustmentPostRequest]);
}
